import React from 'react';
import { GridProps, Typography } from '@material-ui/core';

import { StyledGrid } from './InlineTextField';

export interface InlineFormControlProps extends GridProps {
  label?: string;
}

export const InlineFormControl: React.FC<InlineFormControlProps> = (
  props: InlineFormControlProps
) => {
  const { label, children, ...gridProps } = props;
  return (
    <StyledGrid item xs={12} {...gridProps}>
      {label && (
        <Typography variant='h5' gutterBottom>
          {label}
        </Typography>
      )}
      {children}
    </StyledGrid>
  );
};
